// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000', // JUANCHO: Change this to whatever the URL of the API will be
  ENDPOINTS: {
    STEPS: '/api/steps',
    TEMPLATES: '/api/templates',
    QUESTIONS: '/api/questions'
  }
};

// Helper to build full URL
export const buildUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
